import { ResponseStatus } from '../services/api/api.service';

export enum SessionType {
    term_rider = 'term_rider',
    independent_rider = 'independent_rider'
  }

export interface Session {
  id: string;
  date: string;
  course_name: string;
  course_type: SessionType;
  venue_name: string;
  start_time: string;
  end_time: string;
  duration: number;
  weekday: string;
}

export class SessionImpl implements Session {
  id: string;
  date: string;
  course_name: string;
  course_type: SessionType;
  venue_name: string;
  start_time: string;
  end_time: string;
  duration: number;
  weekday: string;

  constructor(session: Session) {
    this.id = session.id
    this.date = session.date
    this.course_name = session.course_name
    this.course_type = session.course_type
    this.venue_name = session.venue_name
    this.start_time = session.start_time
    this.end_time = session.end_time
    this.duration = session.duration
    this.weekday = session.weekday
  }

  shortTimeStart() {
    if (!this.start_time) {
      return ''
    }
    return this.start_time.substring(0, 5)
  }

  shortTimeEnd() {
    if (!this.end_time) {
      return ''
    }
    return this.end_time.substring(0, 5)
  }

formatDate(dateString: string): string {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    month: 'long',
    day: 'numeric'
  };
  
  // Get the formatted date (e.g., "May 7")
  const formattedDate = date.toLocaleDateString('en-US', options);
  
  // Convert to format "7 May"
  const [month, day] = formattedDate.split(' ');
  return `${day} ${month}`;
}

  // Convert full weekday to abbreviated form
  abbreviateWeekday(weekday: string): string {
    const weekdayMap: { [key: string]: string } = {
      'Monday': 'Mon',
      'Tuesday': 'Tue',
      'Wednesday': 'Wed',
      'Thursday': 'Thu',
      'Friday': 'Fri',
      'Saturday': 'Sat',
      'Sunday': 'Sun'
    };
    return weekdayMap[weekday] || weekday;
  }

  name(): string {
    return this.formatDate(this.date) + " (" + this.abbreviateWeekday(this.weekday) + ") " + (this.shortTimeStart() ? ' ' + this.shortTimeStart() : '') + ' - ' + this.shortTimeEnd()
  }
}

export interface SessionResponse {
  status: ResponseStatus;
  message: string;
  sessions: Session[];
}



